const FooterFactory = function ($resource, $window) {
    const siteContactInfoParams = {
        gaId: "@gaId"
    };

    return $resource(
        __baseApiUrl__ + "/participant-web-services/rest/sitecontactinfo/:gaId",
        siteContactInfoParams,
        {
            query: {
                method: "GET",
                isArray: false
            }
        }
    );
};

FooterFactory.$inject = ["$resource", "$window"];
export default FooterFactory;
